module.exports = __webpack_public_path__ + "img/95.cdf3c8c.png";